import { useQuery } from '@tanstack/react-query';

import { USER_QUERY_KEYS } from './query-keys';
import { userApi } from './user-api';

export const userQueryOptions = {
  queryKey: USER_QUERY_KEYS.user(),
  queryFn: () => userApi.get(),
  retry: false,
};

export function useUser() {
  return useQuery(userQueryOptions);
}
